<div class="checkout-header-container">
  <div class="content">
    <div class="tabs">
      <a [customRouterLink]="'/' + checkoutBaseRoute + '/' + addressUrl" [active]="isUrl(deliveryUrl) || isUrl(paymentUrl) || isUrl(summaryUrl)" class="tab {{ isUrl(addressUrl) ? 'active' : '' }} {{ isUrl(deliveryUrl) || isUrl(paymentUrl) || isUrl(summaryUrl) ? 'complete' : '' }}">
        <svg class="big" xmlns="http://www.w3.org/2000/svg" width="218" height="48" viewBox="0 0 218 48">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M217.089.5H.5v47h207.557l9.032-47z"/>
        </svg>
        <svg class="small" xmlns="http://www.w3.org/2000/svg" width="52" height="32" viewBox="0 0 52 32">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M51.32.5H.5v31h41.173l9.648-31z"/>
        </svg>
        <div class="tab-content big">
          <svg *ngIf="isUrl(deliveryUrl) || isUrl(paymentUrl) || isUrl(summaryUrl)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
          </svg>
          {{ 'checkout.steps.headline.address' | translate }}
        </div>
        <div class="tab-content start small">
          <svg *ngIf="isUrl(deliveryUrl) || isUrl(paymentUrl) || isUrl(summaryUrl)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
          </svg>
          <span class="number">1</span>
        </div>
      </a>
      <a [customRouterLink]="'/' + checkoutBaseRoute + '/' + deliveryUrl" [active]="isUrl(paymentUrl) || isUrl(summaryUrl)" class="tab {{ isUrl(deliveryUrl) ? 'active' : '' }} {{ isUrl(paymentUrl) || isUrl(summaryUrl) ? 'complete' : '' }}">
        <svg class="big" xmlns="http://www.w3.org/2000/svg" width="219" height="48" viewBox="0 0 219 48">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M217.783.5H10.33L1.3 47.5H208.75l9.033-47z"/>
        </svg>
        <svg class="small" xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M55.32.5H10.362L.68 31.5h44.958L55.32.5z"/>
        </svg>
        <div class="tab-content big">
          <svg *ngIf="isUrl(paymentUrl) || isUrl(summaryUrl)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
          </svg>
          {{ 'checkout.steps.headline.delivery' | translate }}
        </div>
        <div class="tab-content start small">
          <svg *ngIf="isUrl(paymentUrl) || isUrl(summaryUrl)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
          </svg>
          <span class="number">2</span>
        </div>
      </a>
      <a [customRouterLink]="'/' + checkoutBaseRoute + '/' + paymentUrl" [active]="isUrl(summaryUrl)" class="tab {{ isUrl(paymentUrl) ? 'active' : '' }} {{ isUrl(summaryUrl)? 'complete' : '' }}">
        <svg class="big" xmlns="http://www.w3.org/2000/svg" width="219" height="48" viewBox="0 0 219 48">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M217.783.5H10.33L1.3 47.5H208.75l9.033-47z"/>
        </svg>
        <svg class="small" xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M55.32.5H10.362L.68 31.5h44.958L55.32.5z"/>
        </svg>
        <div class="tab-content big">
          <svg *ngIf="isUrl(summaryUrl)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
          </svg>
          {{ 'checkout.steps.headline.payment' | translate }}
        </div>
        <div class="tab-content start small">
          <svg *ngIf="isUrl(summaryUrl)" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#35CD05" fill-rule="evenodd" d="M14.843 18.711L3.689 7.847 10.622 0.914 12.914 3.117 8.102 7.847 16.965 16.507z" transform="rotate(-90 10.327 9.812)"/>
          </svg>
          <span class="number">3</span>
        </div>
      </a>
      <a [customRouterLink]="'/' + checkoutBaseRoute + '/' + summaryUrl" [active]="false" class="tab {{ isUrl(summaryUrl) ? 'active' : '' }}">
        <svg class="big" xmlns="http://www.w3.org/2000/svg" width="219" height="48" viewBox="0 0 219 48">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M217.582.5H10.025l-9.032 47h216.589V.5z"/>
        </svg>
        <svg class="small" xmlns="http://www.w3.org/2000/svg" width="52" height="32" viewBox="0 0 52 32">
          <path class="tab-background" fill="none" fill-rule="evenodd" stroke="#CCCDD1" d="M.68 31.5H51.5V.5H10.327l-9.648 31z"/>
        </svg>
        <div class="tab-content big">
          {{ 'checkout.steps.headline.summary' | translate }}
        </div>
        <div class="tab-content start small">
          <span class="number">4</span>
        </div>
      </a>
    </div>
  </div>
</div>
